import { RootState } from '../../store';

export const getTitle = (state: RootState) => state.alert.title;

export const getText = (state: RootState) => state.alert.bodyText;

export const isShown = (state: RootState) => state.alert.isShown;

export const isClosed = (state: RootState) => state.alert.isClosed;

export const getType = (state: RootState) => state.alert.type;

export const isLogoPopUpOpen = (state: RootState) =>
  state.alert.isLogoPopUpOpen;

export const isCategoriesPopUpOpen = (state: RootState) =>
  state.alert.isCategoriesPopUpOpen;
